import Vue from 'vue'
import VueI18n from 'vue-i18n'
import lodash from 'lodash/object'

import basic from './modules/basic-translation'
import farm from './modules/farm-translation'
import animal from './modules/animal-translation'
import log from './modules/log-translation'
import security from './modules/security-translation'

Vue.use(VueI18n)

const messages = lodash.mergeWith(basic, farm, animal, log, security)

const i18n = new VueI18n({
    fallbackLocale: 'ru',
    locale: 'ru',
    messages
})

export default i18n
